/**
 * 테이블 콘텐츠 총 개수 넣으면 index 반대로 뒤집은 배열 return
 * 사용은 reverseIndex(contents.length)[index]
 * @param total
 * @returns [5, 4, 3, 2, 1]
 */
export const reverseIndex = (total: number): number[] => {
  return Array.from({ length: total }, (_, index) => index + 1).reverse();
};
